import { Link } from "react-router-dom";
import { services } from "@/mocks/updiag";

export default function ServicesSection() {
  const featured = services[0];
  const others = services.slice(1, 4);

  return (
    <section className="bg-[#F8FAFC] py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-orange-100 text-[#F97316] text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            Nos services
          </span>
          <h2 className="text-4xl font-extrabold text-[#0F3B5F] mb-4" style={{ fontFamily: "Barlow, sans-serif" }}>
            Tous vos diagnostics immobiliers
          </h2>
          <p className="text-lg text-gray-500 max-w-2xl mx-auto">
            Certifiés COFRAC, nos diagnostiqueurs réalisent l'ensemble des diagnostics obligatoires pour la vente et la location en Île-de-France.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* Featured DPE */}
          <div className="lg:col-span-2 relative bg-white rounded-2xl p-8 border border-orange-100 hover:-translate-y-1 transition-all duration-300 group overflow-hidden">
            <div className="absolute top-4 right-4 bg-[#F97316] text-white text-xs font-bold px-3 py-1 rounded-full">
              ★ Service phare
            </div>
            <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-[#F97316] to-orange-600 rounded-2xl mb-5">
              <i className="ri-fire-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#0F3B5F] mb-2" style={{ fontFamily: "Barlow, sans-serif" }}>
              DPE
            </h3>
            <p className="text-sm text-gray-500 mb-1 font-medium">Diagnostic de Performance Énergétique</p>
            <p className="text-gray-500 text-sm leading-relaxed mb-5">
              Obligatoire pour toute vente ou location, le DPE évalue la consommation énergétique de votre bien et son impact environnemental. Validité 10 ans.
            </p>
            <ul className="flex flex-col gap-2 mb-6">
              {featured.points.map((pt) => (
                <li key={pt} className="flex items-center gap-2 text-sm text-gray-600">
                  <i className="ri-checkbox-circle-fill text-[#16A34A]"></i>
                  {pt}
                </li>
              ))}
            </ul>
            <div className="flex items-center justify-between">
              <span className="text-2xl font-extrabold text-[#0F3B5F]" style={{ fontFamily: "Barlow, sans-serif" }}>
                Dès 130 €
              </span>
              <Link
                to="/diagnostics/dpe"
                className="flex items-center gap-2 px-5 py-2.5 border-2 border-[#F97316] text-[#F97316] rounded-xl text-sm font-bold hover:bg-[#F97316] hover:text-white transition-all duration-200 whitespace-nowrap"
              >
                En savoir plus <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>

          {/* Other services */}
          {others.map((svc) => (
            <div
              key={svc.id}
              className="bg-white rounded-2xl p-6 border border-gray-100 hover:-translate-y-1 transition-all duration-300 group"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#0F3B5F]/5 rounded-xl mb-4 group-hover:bg-[#0F3B5F]/10 transition-colors">
                <i className={`${svc.icon} text-[#0F3B5F] text-2xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-[#0F3B5F] mb-1" style={{ fontFamily: "Barlow, sans-serif" }}>{svc.name}</h3>
              <p className="text-xs text-gray-400 mb-3 font-medium">{svc.fullName}</p>
              <p className="text-sm text-gray-500 leading-relaxed mb-4">{svc.description}</p>
              <ul className="flex flex-col gap-1.5 mb-5">
                {svc.points.map((pt) => (
                  <li key={pt} className="flex items-center gap-2 text-xs text-gray-500">
                    <i className="ri-checkbox-circle-fill text-[#16A34A] text-sm"></i>
                    {pt}
                  </li>
                ))}
              </ul>
              <div className="flex items-center justify-between mt-auto">
                <span className="text-lg font-extrabold text-[#0F3B5F]" style={{ fontFamily: "Barlow, sans-serif" }}>{svc.price}</span>
                <Link
                  to={`/diagnostics/${svc.slug}`}
                  className="text-sm text-[#F97316] font-semibold hover:underline whitespace-nowrap"
                >
                  Voir <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* CTA voir tous */}
        <div className="text-center mt-10">
          <Link
            to="/diagnostics"
            className="inline-flex items-center gap-2 px-8 py-3.5 border-2 border-[#0F3B5F] text-[#0F3B5F] rounded-xl font-bold hover:bg-[#0F3B5F] hover:text-white transition-all duration-200 whitespace-nowrap"
          >
            Voir tous nos diagnostics
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
